module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 4")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Saturday, November 3"), _c('br'), _vm._v(" 9:30 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("R")])]), _vm._v("ick’s Island Hideaway was the quintessential Key West bar: Jimmy Buffet on the sound system; killer frozen margaritas; a friendly clientele whose attire never veered far from shorts and Hawaiian-print shirts; walls hung with maritime paraphernalia, including a stuffed sailfish and a signed photo of Key West’s most famous onetime resident, Ernest Hemingway. It was the same photo that could be found in about ninety percent of the Duval Street drinking establishments.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And last but certainly not least, a bartender who could charm the skin off a snake.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("The ability to do just that came as naturally to Rick Wells as breathing. It was an ability, a gift, really, that Rick depended on but didn’t pride himself in. There ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("were many ways to hide from life, he knew. On a bar stool was one way. Behind a killer smile was another.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What can I get you?” Rick asked the man who slid onto the stool in front of him. Judging by his starched and pressed shirt and obvious hangover, he was a tourist. And not one who had stopped in for a cup of coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Uncle Jack, black. Straight up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jack Daniel’s, black label.")]), _vm._v(" At only 9:30 a.m., the coffee would have been a better choice, Rick thought. But he wasn’t this guy’s mother, wife or pastor. Rick poured the shot and slid it across the bar. “Big night last night?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man nodded, a ghost of a smile touching his mouth. “This place is all right.” He brought the glass to his lips. “You don’t happen to have a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")]), _vm._v(" I could buy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tough to get the current "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Times")]), _vm._v(" here. They sell out fast for an exorbitant price. It’s a matter of geography, my friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The tourist swore. “Great. My wife’s going to be more pissed at me than she already is.” He shook his head. “The older wives get, the less of a sense of humor they have.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Couldn’t say, my friend. That’s not my area.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man shot him an envious glance. “Not married, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not anymore,” Rick responded, forcing a light tone, cursing the sudden tightness in his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, take it from me, it’s true.” The man downed the shot, then nudged the glass back to Rick for a refill. “No "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Times.")]), _vm._v(" Imagine that.” He shook his head, his expression a cross between disbelief and bemusement. “You seem like a pretty with-it guy, how do you manage?”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t mind giving up a few conveniences to live in paradise.” Rick refilled the glass, a smile tugging at the corners of his mouth. “Besides, the news isn’t going to change if I don’t read it today. It’ll be just as screwed up tomorrow. Or the day after.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve got a point, man. September eleventh fucked everything up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you want news, I suggest the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Miami Herald.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The tourist downed the second shot. “You wouldn’t happen to have one, would you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure do.” Rick reached under the bar for his copy, which he had already read, cover to cover. He laid it on the counter. “Enjoy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, I—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Marty,” a woman called from the bar’s open doorway, her tone disgusted, “I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("thought")]), _vm._v(" you were finding me a paper?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man rolled his eyes at Rick and stood. “Got it, sweetheart.” He tossed a ten-dollar bill on the bar, scooped up the papers, then hurried toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nice talking to you,” Rick called after him, then smiled as Valentine Lopez strolled through the bar entry. Valentine—Val to everyone but his mother and the priest who had baptized him—was Rick’s oldest friend.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, if it isn’t Key West’s own version of Dick Tracy. I’m honored.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You should be, buddy,” Val responded, crossing to Rick. “Still wasting away in Margaritaville, I see.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Everybody’s got to have a talent.” Rick grinned and motioned to the stool in front of him. “Take a load off.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("The two men were “conchs,” the tag given to Key West natives, though they came from very different ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("backgrounds. Rick’s family was a Key West import, his father a doctor, his mother a socialite from West Palm Beach. On a vacation to the island, his parents had caught what the locals called the “Key West disease.” Before their week-long vacation ended, they had decided they never wanted to leave. His father had sold his Tampa practice and opened one on the island.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Val’s family, on the other hand, descended from some of the original Cuban inhabitants of the island. His ancestors had been involved in both the cigar-making and sponging industries. Val’s father—now deceased—had been a shrimper. A noble occupation though not a particularly lucrative one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The two boys would probably never have met, let alone become as close as brothers, if they had grown up anywhere else. But despite their disparate means and backgrounds Rick and Val had fallen into an unshakable friendship. A friendship tested only once: when Rick married the girl of Val’s dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Val sat. “Got any coffee back there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The best café con leche on the island.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My mother would argue with that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Second best, then. No way I’m getting into a pissing match with that little woman. She’s tough.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick went about preparing the Cuban espresso and hot milk. “How are things down at the department?” he asked, raising his voice to be heard over the roar of the espresso machine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let me put it this way, when you decide to grow up, let me know. I could use you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Key West Police Department consisted of eighty-one sworn officers and twenty-two civilian personnel. Val was the ranking detective on the force and one of five officers who reported directly to the chief of police.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Use me? Geez, things must really suck.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Val sobered. “I mean it, Rick. You’re a cop. One of the best I’ve ever—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Was a cop,” Rick corrected. He set the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("con leche")]), _vm._v(" in front of his friend. “A long time ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Are")]), _vm._v(" a cop,” Val repeated. “It’s in your blood. It’s what you—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Joke’s over, Val,” Rick muttered. “I suggest you not go there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s been more than three years. You need to let them go.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Emotion rose up in Rick, nearly strangling him. “Don’t tell me what I need. Don’t you…dare tell me that I need to do that. I’ll never let them go. Never.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Silence fell between the two men. Until three years ago, Rick had been a detective with the Key West Police Department and before that with the Miami-Dade force. He’d had the reputation for being smart and fearless, a seasoned hotshot with a killer instinct and an unwillingness to say die.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tragedy forced Rick out of Miami. His wife had been diagnosed with ovarian cancer and only a handful of months later, he found himself a widower. And single father to a grief-stricken five-year-old son. Despondent, in need of friends, family and a better place to raise Sam, he’d returned to Key West.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Val had quickly gotten him a spot on his team at the KWPD. Although it had been a big adjustment to go from lead detective on complex and high-profile murder cases to investigating open-and-shut burglary and assault cases, Rick had been grateful for the opportunity. And for the small-town pace.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("His peace had been shattered only a matter of months later: two armed men had broken into Rick’s home in ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("the middle of the night. Shots had broken out and Sam, awakened by the commotion, had gotten caught in the cross fire.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ballistics had proved that Sam had been killed by one of Rick’s bullets.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Val pushed his coffee away and stood. “I’ve worn out my welcome this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t be a jerk.” Rick scowled at the other man. “Drink your coffee or I’ll have to kick your ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Val sat, a smile tugging at his mouth. “Kick "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" ass? You wish. You’re out of shape, my friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The truth was, the two men were as different physically as they were genetically. Val was small, with a wiry build and the coloring of his Cuban ancestors. Rick was big—six foot three—with blue eyes and fair hair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You think?” Rick looked down at his gut. “Can’t pinch an inch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s all about training, my friend. My body’s a lethal instrument, while yours—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick burst out laughing. “By any chance, is that the line you use with the ladies? Because, well…I think I should warn you, it’s pretty cheesy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Val, still single and a self-avowed playboy, grinned. “To you, maybe. But to the ladies, pure nectar.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Excuse me while I puke.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know it’s hard to take. But it’s true, I’m a chick magnet. I could fix you up.” The corner of his mouth lifted. “We could double-date, like we did when we were in high school.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pass on that, buddy. Thanks anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jill’s gone,” Val murmured. “Almost four years now.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Rick averted his gaze, staring at the open doorway ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("and the brilliant rectangle of light beyond. “That guy who was leaving when you walked in, he was complaining about his wife. Envying my single state. And all I could think was how not a day goes by that I don’t wish she’d lived long enough to make my life a living hell.”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Val swore softly. “I’m sorry, man. I didn’t mean—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Forget it. It’s my problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Several moments of strained silence passed between them. Val drained his cup. “Gotta go, crime calls.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Anything interesting?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Missing person.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("poof,")]), _vm._v(" gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t know for sure.” Val stood. “The supervisor of Island National Bank’s processing center didn’t show up for work yesterday. A friend and coworker tried to reach her and couldn’t. When she didn’t show up for their morning run this morning, her friend called us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick frowned. “That’s Naomi Pearson, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah. You know her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m a bartender. I know almost everybody on the island.” He searched his memory for how or when he had first met her. “I financed the Hideaway through Island National. I think I met her one time when I was up there. I hope she’s okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure she is. Probably met some guy and took off.” Val saluted. “Give me a call sometime. I’m in the book.”")])])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page34"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06743830","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459280410_ch04.vue
// module id = 90
// module chunks = 0